window.addEventListener('DOMContentLoaded', function () {
  // Swiper init
  new Swiper('.fatco-swiper', {
    loop: true,
    spaceBetween: 30,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      }
    }
  });
});
